import { editions as EditionContainer } from "../Analysis/containers";

export default function VideoEditor() {
  return <EditionContainer />;
}
